// Discounts at `/discounts`. Volume-discount tiers in a 3-column grid
// of Cards, plus a contact CTA below.

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  H1,
  P,
} from '@podium/platform/ui'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/discounts')({
  component: DiscountsPage,
})

const TIERS = [
  {
    range: '10 – 49 отчета',
    discount: '10% отстъпка',
    perks: 'от промоционалната цена',
  },
  {
    range: '50 – 99 отчета',
    discount: '15% отстъпка',
    perks: 'плюс персонален акаунт мениджър',
  },
  {
    range: '100+ отчета',
    discount: 'Индивидуална оферта',
    perks: 'възможност за автоматизирано подаване (API)',
  },
] as const

function DiscountsPage() {
  return (
    <div className="mx-auto max-w-5xl space-y-6 px-6 py-8">
      <div className="space-y-2">
        <H1>Отстъпки</H1>
        <P className="text-muted-foreground">
          За счетоводни кантори и предприятия, които публикуват отчети на повече от 10 фирми в
          рамките на една година, предлагаме групови отстъпки и опростен процес на подаване с един
          общ акаунт.
        </P>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {TIERS.map((t) => (
          <Card key={t.range}>
            <CardHeader>
              <CardTitle className="text-base">{t.range}</CardTitle>
              <CardDescription>{t.discount}</CardDescription>
            </CardHeader>
            <CardContent>
              <P className="text-sm text-muted-foreground">{t.perks}</P>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Заявка за групова отстъпка</CardTitle>
        </CardHeader>
        <CardContent>
          <P>
            Свържете се с нас на{' '}
            <a href="mailto:office@godishni-otcheti.com">office@godishni-otcheti.com</a> с посочени
            брой предприятия и период, или използвайте <a href="/contact">формата за контакт</a>.
          </P>
        </CardContent>
      </Card>
    </div>
  )
}
